var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30002 8.47997L16.5 3.29851L28.7 8.47997C29.0933 8.6469 29.3066 9.00078 29.3 9.33464C29.2733 15.4375 26.74 25.9808 16.88 30.7082C16.64 30.8217 16.36 30.8217 16.1267 30.7082C6.26002 25.9741 3.73336 15.4375 3.70002 9.32796C3.70002 8.99411 3.90669 8.6469 4.30002 8.47329V8.47997ZM29.9466 5.52867L17.3933 0.193637C17.1133 0.0667714 16.8133 0 16.5 0C16.1867 0 15.8867 0.0667714 15.6067 0.193637L3.05336 5.52867C1.58669 6.14965 0.493364 7.59859 0.50003 9.348C0.533364 15.9717 3.25336 28.0907 14.74 33.5994C15.8533 34.1335 17.1467 34.1335 18.26 33.5994C29.7533 28.0907 32.4666 15.9717 32.5 9.348C32.5066 7.59859 31.4133 6.14965 29.9466 5.52867ZM24.0333 13.9552C24.66 13.3276 24.66 12.3126 24.0333 11.6917C23.4067 11.0707 22.3933 11.064 21.7733 11.6917L14.3733 19.1033L11.24 15.965C10.6133 15.3374 9.60001 15.3374 8.98001 15.965C8.36001 16.5927 8.35335 17.6076 8.98001 18.2286L13.2467 22.502C13.8733 23.1296 14.8867 23.1296 15.5067 22.502L24.0333 13.9552Z",
    fill: "#C1C5C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckMark);
export default __webpack_public_path__ + "static/media/shield-check-mark.cb935dfcc6e2fecb034699221b4d4985.svg";
export { ForwardRef as ReactComponent };